import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import PasswordReset from 'components/PasswordReset';

const RecoverPwdLanding = ({ className }) => {
  const { t } = useTranslation('RecoverPassword');
  const { token } = useParams();

  return (
    <div className={className} data-testid="RecoverPwdLanding">
      <div className="recover-pwd-landing">
        <div className="recover-pwd-landing__background">
          <div className="recover-pwd-landing__container">
            <h1
              className="recover-pwd-landing__title"
              data-testid="recover-pwd-landing__title"
            >
              {t('landingTitle')}
            </h1>
            <p className="recover-pwd-landing__text">{t('landingSubtitle')}</p>
            <PasswordReset recoverToken={token} />
          </div>
        </div>
      </div>
    </div>
  );
};

RecoverPwdLanding.propTypes = {
  className: PropTypes.string
};

export default RecoverPwdLanding;
